import { PropsWithChildren } from 'react';
import { useTheme } from '@mui/material';

import { Flex } from '@/components/utils';

export const PopoverSection = (props: PropsWithChildren) => {
  const { palette } = useTheme();

  return (
    <Flex
      column
      borderBottom={`1px solid ${palette.divider}`}
      sx={{
        py: '10px',
        '*': {
          color: '#424242',
        },
      }}
    >
      {props.children}
    </Flex>
  );
};
